import {
  type AdminTalentDetail,
  type RemoveTalentPhotoBody,
  type TalentSearchPage,
} from '@/contracts';

import { authenticated } from '../auth-client';
import { API_PREFIX } from '../http';

export const talentsEndpoints = {
  searchTalents(params: Record<string, string> = {}) {
    const query = new URLSearchParams(params).toString();
    return authenticated<TalentSearchPage>(
      `${API_PREFIX}/admin/talents${query ? `?${query}` : ''}`,
    );
  },

  /** One talent: profile, credentials with their audit state, plan and activity. */
  talent(candidateId: string) {
    return authenticated<AdminTalentDetail>(`${API_PREFIX}/admin/talents/${candidateId}`);
  },

  /** Delete a candidate from the console. The reason is compulsory and audited (C5). */
  deleteTalent(candidateId: string, reason: string) {
    return authenticated<void>(
      `${API_PREFIX}/admin/talents/${candidateId}?reason=${encodeURIComponent(reason)}`,
      { method: 'DELETE' },
    );
  },

  /**
   * Takes a talent's profile photo down. The reason is compulsory: it goes to the
   * audit log and to the talent, who is told why the photo went rather than finding
   * it gone.
   */
  removeTalentPhoto(candidateId: string, reason: string) {
    const body: RemoveTalentPhotoBody = { reason };
    return authenticated<void>(`${API_PREFIX}/admin/talents/${candidateId}/photo`, {
      method: 'DELETE',
      body,
    });
  },
};
